/**
 * A very ghetto React implementation of Bootstrap modal
 * which still relies on jQuery and Bootstrap's JS.
 **/
var Modal = React.createClass({
  propTypes: {
    onHide: React.PropTypes.func.isRequired,
    show: React.PropTypes.bool.isRequired,
    transition: React.PropTypes.bool,
    hideOnBackdropClick: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      transition: true,
      hideOnBackdropClick: true
    }
  },
  childContextTypes: {
    modalOnHide: React.PropTypes.func
  },
  getChildContext() {
    return {
      modalOnHide: this.props.onHide
    }
  },
  componentWillReceiveProps(nextProps) {
    if (!nextProps.show && this.props.show) {
      this.doHide = true;
      this.$modal.modal("hide");
    }

    if (nextProps.show && !this.props.show) {
      this.$modal.modal("show");
    }
  },
  hideTriggered() {
    if (this.doHide) {
      // allow jQuery to hide the modal and reset private control var
      this.doHide = false;
    } else {
      // do not allow jQuery to hide. Call onHide function from parent
      this.props.onHide();
      return false;
    }
  },
  gotDOMRef(element) {
    if (this.$modal == undefined) {
      // initialization
      this.$modal = $(element);
      this.$modal.on("hide.bs.modal", this.hideTriggered);

      if (this.props.show) {
        this.$modal.modal("show");
      }
    }
  },
  render() {
    let className = classNames("modal", {"fade" : this.props.transition});
    let attr = {
      className: className,
      role: "dialog",
      tabIndex: -1,
      "data-backdrop": this.props.hideOnBackdropClick ? "true" : "static"
    };

    return (
      <div {...attr} ref={this.gotDOMRef}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
})


Modal.Header = React.createClass({
  propTypes: {
    onHide: React.PropTypes.func,
    closeButton: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      closeButton: true
    }
  },
  contextTypes: {
    modalOnHide: React.PropTypes.func
  },
  onHide() {

  },
  renderClose() {
    if (!this.props.closeButton) return;

    let onHide = this.props.onHide || this.context.modalOnHide;

    return (
      <button type="button" className="close" aria-label="Close" onClick={onHide}>
        <span aria-hidden="true">&times;</span>
      </button>
    )
  },
  render() {
    return (
      <div className="modal-header">
        {this.renderClose()}
        {this.props.children}
      </div>
    )
  }
})


Modal.Title = React.createClass({
  render() {
    return (
      <h4 className="modal-title">{this.props.children}</h4>
    )
  }
})


Modal.Body = React.createClass({
  render() {
    return (
      <div className="modal-body">
        {this.props.children}
      </div>
    )
  }
})


Modal.Footer = React.createClass({
  render() {
    return (
      <div className="modal-footer">
        {this.props.children}
      </div>
    )
  }
})